<template>
<div class="advImage" :class="{'mt20':!isMartop}">
    <div class="allyesAdvWrap adv160" ref="ad" :id="advCode">
    </div>
</div>
</template>

<script>
import $ from 'jquery'
import {
    sendScData
} from "@/utils/buriedPoint";
export default {
    name: "advImage",
    props: ['advCode', 'isMartop', 'sendSc', 'current_page', 'banner_belong_area', 'banner_name','ddCode'],
    data() {
        return {
            advData: [],
            divTop: '',
            sendFlag: true
        }
    },
    mounted() {
        let el = this.$refs['ad']
        this.renderAD(el)

    },
    methods: {

        showDiv() {
            let that = this
            //获取滚动条距离页面顶部的距离，如果滚动条距离页面距离大于目标元素距离页面顶部的距离，则目标元素已经往上滚动，且超出了当前可视区域，则给该元素添加fixed属性
            var scroolTop = document.documentElement.scrollTop;
            if (!(scroolTop >= this.divTop)) {

           
                if (this.sendFlag) {
                    sendScData('bannerExpose', {
                        cur_page:that.current_page,
                        banner_type_id: $("#"+that.advCode+" a").data('tp-type') || '',
                        banner_order_id:$("#"+that.advCode+" a").data('orderid') || '',
                        banner_advertiser_id: $("#"+that.advCode+" a").data('advertiserid') || '',
                        remarks: $("#"+that.advCode+" a").data('remarks') || '',
                        banner_link_type:$("#"+that.advCode+" a").data('link_type') || '',
                        banner_link: $("#"+that.advCode+" a").data('link') || '',
                        banner_englishName: that.ddCode || '',
                        // banner_belong_area: this.banner_belong_area,
                        // banner_name: this.banner_name,
                        // banner_id: this.advCode,
                    });
                    this.sendFlag = false
                    window.removeEventListener('scroll', this.showDiv, false);
                }

            }
        },
        renderAD(el) {
            fetch('https://show.artron.net/g?english=' + this.advCode).then(r => r.text()).then(res => {
                let document = {
                    write: text => {
                        el.innerHTML += text
                        this.ifShow = text != '' ? true : false
                    }
                }
                eval(res)
                this.switchAdv(el)
            })
        },
        switchAdv(el) {
            let that = this;
            $(function () {
                if (that.sendSc) {
                    that.divTop = document.getElementById(that.advCode).offsetTop;
                    window.onscroll = that.showDiv;
                    $("#"+that.advCode+" a").on("click", function () {
                        sendScData('allClick', {
                                cur_page:that.current_page,
                                banner_type_id: $("#"+that.advCode+" a").data('tp-type') || '',
                                banner_order_id:$("#"+that.advCode+" a").data('orderid') || '',
                                banner_advertiser_id: $("#"+that.advCode+" a").data('advertiserid') || '',
                                remarks: $("#"+that.advCode+" a").data('remarks') || '',
                                banner_link_type:$("#"+that.advCode+" a").data('link_type') || '',
                                banner_link: $("#"+that.advCode+" a").data('link') || '',
                                banner_englishName: that.ddCode || '',
                        });
                    })

                }

                let me = $(el)
                let length = me.children().length,
                    index = 0,
                    onceTime = me.data("once") || 3500;
                me.children().attr('target', '_blank')
                if (length <= 1) {
                    return;
                }
                var toggleInterval = setInterval(function () {
                    if (index >= length - 1) {
                        index = 0;
                    } else {
                        index++;
                    }
                    me.children("a:eq(" + index + ")").show().siblings("a").hide();
                }, onceTime);

            })
        }
    }
}
</script>

<style scoped>

</style>
